import * as React from 'react';
export const UASvg = React.forwardRef(function UASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#45B2E8',
        d: 'M1.994 2h12.012C15.106 2 16 2.894 16 3.998V8H0V3.998C0 2.898.893 2 1.994 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 8h16v4.002c0 1.1-.893 1.998-1.994 1.998H1.994C.894 14 0 13.106 0 12.002V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 8h1v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8h1v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8Z',
      }),
    ),
  );
});
UASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var UA = {
  category: 'flag',
  colorable: false,
  name: 'UA',
  svg: UASvg,
};
